import * as ActionTypes from '../actions';
import { combineReducers } from 'redux';

//function homeSections(state = {sections: []}, action) {
//    if (action.response && action.response.result) {
//        if (action.type === ActionTypes.HOME_SECTION_SUCCESS) {
//            return {
//                sections: action.response.result
//            };
//        }
//    }
//    return state;
//}
//// Updates an entity cache in response to any action with response.entities.
//function demos(state = {demosList: null, demoDetail: null}, action) {
//    if (action.response && action.response.result) {
//        if (action.type === ActionTypes.DEMO_LIST_SUCCESS) {
//            return {
//                demosList: action.response.result,
//                demoDetail: state.demoDetail
//            };
//        } else if (action.type === ActionTypes.DEMO_DETAIL_SUCCESS) {
//            return {
//                demosList: state.demosList,
//                demoDetail: action.response.result
//            };
//        }
//    }
//
//    return state;
//}

function viewportDimension(state = { demosList: null, demoDetail: null }, action) {
    const { type, size } = action;
    if (type === ActionTypes.VIEWPORT_RESIZE) {
        return {
            width: size.width,
            height: size.height
        };
    }
    return state;
}

function filterString(state = null, action) {
    const { type, keyword } = action;
    if (type === ActionTypes.DEMO_FILTER) {
        return { filter: keyword, oldFilter: state && state.filter };
    }
    if (state && state.filter) {
        state.oldFilter = state.filter;
    }
    return state;
}

function updateNaviTree(state = { naviTreeCollapsed: {} }, action) {
    const { type, key } = action;
    let newState;
    if (type === ActionTypes.NAVI_TREE_TOGGLE) {
        newState = JSON.parse(JSON.stringify(state.naviTreeCollapsed));
        newState[key] = !newState[key];
        return { naviTreeCollapsed: newState };
    } else if (type === ActionTypes.NAVI_TREE_EXPAND) {
        newState = JSON.parse(JSON.stringify(state.naviTreeCollapsed));
        newState[key] = false;
        return { naviTreeCollapsed: newState };
    }
    return state;
}

function updateUserLang(state = { lang: 'en' }, action) {
    const { type, lang } = action;
    if (type === ActionTypes.CHANGE_USER_LANG) {
        return { lang: lang };
    }
    return state;
}



const rootReducer = combineReducers({
    viewportDimension,
    updateNaviTree,
    filterString,
    updateUserLang
});

export default rootReducer;



// WEBPACK FOOTER //
// ./client/reducers/index.js